<template>
  <div class="game-controls">
    <div
      class="game-controls__ready"
      @click="nextRound"
      v-text="lastRound ? 'Confirm the last round' : 'Ready for next round'"
    />
    <Time />
    <Rounds />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Rounds from "@/components/game/controls/Rounds.vue";
import Time from "@/components/game/controls/Time.vue";

export default {
  name: "GameControls",
  components: {
    Rounds,
    Time,
  },
  methods: {
    async nextRound() {
      await this.$store.dispatch("waitForNextRound");
    },
  },
  computed: {
    ...mapGetters(["activeGame"]),
    lastRound() {
      return (
        this.activeGame && this.activeGame.turn === this.activeGame.maxTurn
      );
    },
  },
};
</script>

<style>
</style>
